import {BasePanelPage, BasePanelPageStyle} from "../../../../PanelPage.jsx";
import {registerStyle} from "../../../../../../stem-core/src/ui/style/Theme.js";
import {iFrameUserDataService} from "../../../../../services/IFrameUserDataService.js";
import {SubscriptionApplyPolicy} from "../../../../../../client/state/SubscriptionStore.js";
import {Messages} from "../../../../../Messages.js";
import {MessageElement} from "../../../../../widget/ui/MessageElement.jsx";
import {CheckboxInput} from "../../../../../../core/ui/input/checkbox/CheckboxInput.jsx";
import {styleRule} from "../../../../../../stem-core/src/decorators/Style.js";
import {BackButton} from "../../../../../../core/ui/LinkButton.jsx";
import {Flow} from "../../../../flows/Flow.js";
import {BlinkButton} from "../../../../../../core/ui/Button.jsx";


export class EditSubscriptionConfirmPanelStyle extends BasePanelPageStyle {
    @styleRule
    checkbox = {
        color: "inherit",
        fontSize: "inherit",
        marginBottom: 8,
    };

    @styleRule
    lineSeparator = {
        width: "100%",
        borderBottom: "1px solid " + this.themeProps.MERCHANT_FRAME_HEADER_BORDER_COLOR,
    };

    @styleRule
    reviewItemTitle = {
        textTransform: "uppercase",
        marginBottom: 8,
        fontWeight: this.themeProps.FONT_WEIGHT_BOLD,
    };
}

@registerStyle(EditSubscriptionConfirmPanelStyle)
export class EditSubscriptionConfirmPanel extends BasePanelPage {
    getDefaultOptions() {
        return {
            ...super.getDefaultOptions(),
            title: Messages.reviewChange,
        }
    }

    render() {
        const {selectedOffer, applyPolicy} = Flow.subscriptionPlan;

        const activeSubscription = iFrameUserDataService.getActiveSubscription();
        const selectedCoverage = selectedOffer == null ? activeSubscription.coverage : selectedOffer.coverage;
        const selectedBillingPlan = selectedOffer == null ? activeSubscription.billingPlan : selectedOffer.billingPlan;

        // Since for TNR for instance we might now know the new price, we're defaulting prices to activeSubscription.nextCyclePrice
        // TODO This should really be modeled
        const instantPayInfo = Flow.subscriptionPlan.getDiscountInfoOnInstantChangePolicy(selectedOffer) || activeSubscription.nextCyclePrice;
        const nextCyclePayInfo = Flow.subscriptionPlan.getDiscountInfo(selectedOffer) || activeSubscription.nextCyclePrice;


        const {styleSheet} = this;
        const paidUntil = activeSubscription.getPaidUntil();
        const nextBillingDate = activeSubscription.getNextBillingDate();

        const paymentInfoMessageArgs = [
            selectedBillingPlan.formatPrice(nextCyclePayInfo.finalPrice),
            selectedBillingPlan.getCycleDuration(true),
            nextBillingDate.format("MMM DD, YYYY")
        ];

        const updatePaymentInfo = applyPolicy === SubscriptionApplyPolicy.NEXT_BILLING_CYCLE ? [
                Messages.updateAtEndCyclePaymentInfo(...paymentInfoMessageArgs),
                Flow.subscriptionPlan.userHasEquivalentSubscriptionToSelected() ? "" : Messages.updateAtEndCycleChangeOffer].join("")
            : Messages.updateInstantlyPaymentInfo(selectedBillingPlan.formatPrice(instantPayInfo.finalPrice), ...paymentInfoMessageArgs);

        let checkboxElement = null;
        if (instantPayInfo.finalPrice !== nextCyclePayInfo.finalPrice) {
            checkboxElement = <CheckboxInput
                label={Messages.updateAtEndCycleCheckbox(paidUntil.format("MMM DD, YYYY"))}
                className={styleSheet.checkbox}
                onChange={enabled => {
                    Flow.subscriptionPlan.applyPolicy = enabled ? SubscriptionApplyPolicy.NEXT_BILLING_CYCLE : SubscriptionApplyPolicy.INSTANTLY;
                    this.redraw();
                }}
                initialValue={applyPolicy === SubscriptionApplyPolicy.NEXT_BILLING_CYCLE}
            />;
        }

        return [
            !Flow.subscriptionPlan.userHasEquivalentSubscriptionToSelected() &&
                <div>
                    <div className={styleSheet.reviewItemTitle}>
                        {Messages.subscriptionPlan}
                    </div>
                    <MessageElement message={Messages.updateSubscriptionPlanDescription(selectedCoverage.name, selectedBillingPlan.formatPrice(nextCyclePayInfo.finalPrice))}/>
                    <div className={styleSheet.lineSeparator}/>
                </div>,

            (selectedCoverage.requiresAddress || (selectedOffer != null && selectedOffer.shouldCollectAddress())) &&
                <div>
                    <div className={styleSheet.reviewItemTitle}>
                        {Messages.address}
                    </div>
                    <MessageElement message={Messages.updateSubscriptionPlanAddress(Flow.address.selectedValue.toString())}/>
                    <div className={styleSheet.lineSeparator} />
                </div>,

            !Flow.subscriptionPlan.userHasEquivalentSubscriptionToSelected() &&
                <div>
                    <div className={styleSheet.reviewItemTitle}>
                        {Messages.payment}
                    </div>
                    {checkboxElement}
                    <MessageElement message={updatePaymentInfo}/>
                </div>,

            <BlinkButton
                label={Messages.changeSubscription}
                className={styleSheet.actionButton}
                onClick={() => Flow.editSubscriptionConfirmation.updateAndResolve()}
            />,

            <BackButton/>
        ];
    }
}
